import moment from "jalali-moment";
import LineChart from "../../common/charts/LineChart";
import Loading from "../../common/loading";

const ProfilesCount = ({ profilesCount, isLoadingProfilesCount }: any) => {
  return (
    <div className="w-full">
      {isLoadingProfilesCount ? (
        <Loading />
      ) : (
        profilesCount?.length > 0 && (
          <LineChart
            categories={profilesCount
              .reverse()
              .map((item: any) => moment(item.day).format("jYYYY-jMM-jDD"))}
            data={profilesCount.map((item: any) => item.count)}
            name="تعداد ثبت‌نام"
            xaxisTitle="تعداد ثبت‌نام"
            background="#A9D284"
          />
        )
      )}
    </div>
  );
};

export default ProfilesCount;
